import { render, staticRenderFns } from "./NumerexPage.vue?vue&type=template&id=45b452f2"
import script from "./NumerexPage.vue?vue&type=script&lang=js"
export * from "./NumerexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports